import {
    Box,
    CircularProgress,
    Dialog,
    DialogContent,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    IconButton,
    Grid,
    Chip,
    Tooltip,
    Popover,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLostCargoReturnDetailPage } from '../context/LostCargoReturnDetailPageContext';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react';
import { SCUIButton } from '../../../atomic/atoms';
import './LostCargoReturnDetail.scss';
import { ReturnCommand } from '../../../services/command';
import Swal from 'sweetalert2';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { SCUIReturnDetailDrawerContent } from '../../Return/ReturnDetail/components';
import { SCUIGeneralDrawer } from '../../../atomic/molecules';
import { LostCargoReturnDetailModalApprove } from './LostCargoReturnDetailModalApprove';
import { Link } from 'react-router-dom';
import { SCUITextFieldWithButton } from '../../../atomic/molecules';
import { LCRD, lcrDetailCls } from '../lostCargoReturnDetailPage.classes';

function LostCargoReturnDetailCustomGrid() {
    const { t } = useTranslation();
    const { returnDetailData } = useLostCargoReturnDetailPage();
    const [openModal, setOpenModal] = React.useState(false);
    const [selectedImage, setSelectedImage] = React.useState('');
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [deletePopoverOpen, setDeletePopoverOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [product, setProduct] = useState<any>();
    const [modalOpen, setModalOpen] = useState(false);
    const [isCompleting, setIsCompleting] = useState(false);
    const [selectedProductBarcode, setSelectedProductBarcode] = useState('');
    const [barcodeNotFound, setBarcodeNotFound] = useState(false);

    const onModalOpen = () => setModalOpen(true);
    const onModalClose = () => setModalOpen(false);
    const onDrawerClose = () => setDrawerOpen(false);
    const handleOpenModal = (imageUrl: any) => {
        setSelectedImage(imageUrl);
        setOpenModal(true);
    };
    const handleClosePopover = () => {
        setDeletePopoverOpen(false);
        setAnchorEl(null);
    };
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const handleClickProductTable = (e: any, product: any) => {
        setProduct(product);
        setDeletePopoverOpen(true);
        setAnchorEl(e.currentTarget);
    };

    const approveProduct = () => {
        handleClosePopover();
        onModalOpen();
    };

    const handleSaveProduct = (updatedProduct: any) => {
        const updatedProducts = (returnDetailData?.productDetailModels || []).map((p: any) => {
            if (!!p.barcode && !!updatedProduct.barcode && p.barcode === updatedProduct.barcode) {
                return updatedProduct;
            }
            return p;
        });

        returnDetailData.productDetailModels = updatedProducts;
        setProduct(updatedProduct);
    };

    const handleCompleteReturn = async (returnDetailData: any) => {
        try {
            setIsCompleting(true);
            const response = await ReturnCommand.CompleteReturnForLostCargo(returnDetailData);

            if (response.returnedProductProcess?.result) {
                await Swal.fire({
                    title: t('general.success'),
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: true,
                    confirmButtonText: t('lostCargoReturnPageBuilder.ok'),
                });
                window.location.href = `/lost-cargo-return-page`;
            } else {
                await Swal.fire(t('general.error'), response.returnedProductProcess?.returnMessages, 'error');
            }
        } catch {
            await Swal.fire(t('general.error'), '', 'error');
        } finally {
            setIsCompleting(false);
        }
    };

    const barcodeSearch = (): void => {
        if (selectedProductBarcode.trim() === '') return;

        const selectedProduct: any[] | undefined =
            returnDetailData?.productDetailModels &&
            (() => {
                const selectedProductsArray: any[] = [];

                for (const product of returnDetailData.productDetailModels) {
                    if (product.barcodeList?.includes(Number(selectedProductBarcode.trim()))) {
                        selectedProductsArray.push(product);
                        break;
                    }
                }

                if (selectedProductsArray.length === 0) {
                    return undefined;
                }

                return selectedProductsArray;
            })();

        if (!selectedProduct) {
            setBarcodeNotFound(true);
        } else if (selectedProduct && selectedProduct.length > 0) {
            setBarcodeNotFound(false);
            setProduct(selectedProduct[0]);
            onModalOpen();
            setSelectedProductBarcode('');
        }
    };

    return (
        <>
            {isCompleting && (
                <Box
                    className={LCRD.completingOverlay}
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        zIndex: 9999,
                    }}
                >
                    <CircularProgress size={100} />
                </Box>
            )}
            {product && (
                <LostCargoReturnDetailModalApprove
                    open={modalOpen}
                    onClose={onModalClose}
                    product={product}
                    returnData={returnDetailData}
                    onSave={handleSaveProduct}
                />
            )}
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                slotProps={{
                    paper: {
                        className: LCRD.imagePreviewDialogPaper,
                        style: {
                            position: 'relative',
                            padding: '20px',
                        },
                    },
                }}
            >
                <IconButton
                    className={LCRD.inputIconImagePreviewClose}
                    onClick={handleCloseModal}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'gray',
                        '&:hover': {
                            color: 'black',
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                    }}
                >
                    <CloseIcon sx={{ fontSize: '24px' }} />
                </IconButton>
                <DialogContent className={LCRD.imagePreviewContent} sx={{ padding: '24px 16px 16px 16px' }}>
                    <img className={LCRD.imagePreviewImg} src={selectedImage} style={{ width: '400px', height: 'auto' }} alt="" />
                </DialogContent>
            </Dialog>
            <SCUIGeneralDrawer
                paperClassName={LCRD.returnProductDrawerPaper}
                open={drawerOpen}
                width={'400px'}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setDrawerOpen(false);
                    }
                }}
            >
                {product && <SCUIReturnDetailDrawerContent product={product} onClose={onDrawerClose} />}
            </SCUIGeneralDrawer>
            <Popover
                open={deletePopoverOpen}
                onClose={handleClosePopover}
                anchorEl={anchorEl}
                slotProps={{ paper: { className: LCRD.rowActionsPopoverPaper } }}
            >
                <MenuItem className={LCRD.inputMenuItemTakeAction} onClick={() => approveProduct()}>{t('general.takeAction')}</MenuItem>
            </Popover>
            <Box className={LCRD.gridOuter} sx={{ marginLeft: '1.5rem' }}>
                <Grid
                    className={LCRD.gridPaper}
                    container
                    spacing={2}
                    sx={{
                        padding: '2rem',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        transition: 'box-shadow 0.3s ease',
                        marginTop: '1rem',
                    }}
                >
                    <Grid
                        size={{
                            xs: 12,
                        }}
                    >
                        {returnDetailData?.isReturnable && returnDetailData.showCompleteButtonForLostCargo && (
                            <Grid
                                className={LCRD.barcodeSearchFieldWrap}
                                sx={{ marginBottom: '1rem' }}
                                size={{
                                    xs: 12,
                                    md: 6,
                                    lg: 4,
                                    xl: 3,
                                }}
                            >
                                <SCUITextFieldWithButton
                                    paperClassName={LCRD.inputCompositeBarcodeSearch}
                                    inputClassName={LCRD.inputTextBarcodeSearch}
                                    buttonClassName={LCRD.inputButtonBarcodeSearch}
                                    value={selectedProductBarcode}
                                    width={300}
                                    placeholder={t('general.barcodeSearch')}
                                    buttonText={t('general.search')}
                                    onChange={(event: any) => {
                                        setSelectedProductBarcode(event.target.value);
                                    }}
                                    onClick={() => barcodeSearch()}
                                    onKeyPress={(e: any) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            barcodeSearch();
                                        }
                                    }}
                                />
                            </Grid>
                        )}
                        {barcodeNotFound && (
                            <Grid className={LCRD.barcodeNotFoundSection} container direction="row" sx={{ padding: '25px' }}>
                                <Grid
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    }}
                                >
                                    <Typography variant="h6" display="block" gutterBottom color="red">
                                        <b>{t('general.productNotFound')} </b>
                                    </Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        xl: 6,
                                    }}
                                >
                                    <Link
                                        to={`/orders?Barcodes=${selectedProductBarcode}&orderStatusIds=4,8`}
                                        target="_blank"
                                    >
                                        <p className={lcrDetailCls('linktxt', LCRD.linkOrdersWithBarcode)}>
                                            {`${selectedProductBarcode}  ${t('general.ordersWithBarcode')}`}
                                        </p>
                                    </Link>
                                </Grid>
                            </Grid>
                        )}
                        {returnDetailData?.productDetailModels && (
                                <TableContainer className={LCRD.productsTableContainer} component={Paper} variant="outlined">
                                    <Table className={LCRD.productsTable} size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow sx={{ height: 50 }}>
                                                <TableCell style={{ textAlign: 'center' }}></TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>
                                                    <strong>{t('general.product')}</strong>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>
                                                    <strong>{t('general.quantity')}</strong>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'center' }} align="right" width={1}>
                                                    <strong>{t('lostCargoReturnPageBuilder.sellable')}</strong>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'center' }} align="right" width={1}>
                                                    <strong>{t('lostCargoReturnPageBuilder.unsellable')}</strong>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'center' }} align="right" width={1}>
                                                    <strong>{t('lostCargoReturnPageBuilder.return')}</strong>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'center' }} align="right" width={1}>
                                                    <strong>{t('lostCargoReturnPageBuilder.returnReason')}</strong>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'center' }} align="right" width={1}>
                                                    <strong>
                                                        {t('lostCargoReturnPageBuilder.returnReasonDetail')}
                                                    </strong>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'center' }} align="right" width={1}>
                                                    <strong>{t('lostCargoReturnPageBuilder.operatorSelection')}</strong>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'center' }} align="right" width={1}>
                                                    <strong>{t('lostCargoReturnPageBuilder.status')}</strong>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'center' }} align="right" width={1}>
                                                    <strong>{t('lostCargoReturnPageBuilder.returnMessage')}</strong>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'center' }} align="right" width={1}>
                                                    <strong>{t('lostCargoReturnPageBuilder.statusMessage')}</strong>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {returnDetailData?.productDetailModels &&
                                                returnDetailData.productDetailModels.map((product: any) => (
                                                    <>
                                                        <TableRow
                                                            className={LCRD.productRow}
                                                            sx={{
                                                                paddingBottom: '3rem',
                                                                height: 50,
                                                                backgroundColor: '#75c693',
                                                            }}
                                                        >
                                                            <TableCell
                                                                className={LCRD.productImageCell}
                                                                align="right"
                                                                style={{
                                                                    textAlign: 'left',
                                                                    margin: 0,
                                                                    padding: '8px',
                                                                }}
                                                                width={100}
                                                            >
                                                                <div
                                                                    className={LCRD.productImageWrap}
                                                                    style={{
                                                                        position: 'relative',
                                                                        display: 'inline-block',
                                                                        padding: '2px',
                                                                        backgroundColor: '#f8f9fa',
                                                                        borderRadius: '4px',
                                                                        transition: 'all 0.3s ease',
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.currentTarget.style.backgroundColor =
                                                                            '#f0f7f0';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.backgroundColor =
                                                                            '#f8f9fa';
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={product.productImageUrl}
                                                                        style={{
                                                                            width: '110px',
                                                                            height: 'auto',
                                                                            display: 'block',
                                                                            borderRadius: '4px',
                                                                        }}
                                                                        alt=""
                                                                    />
                                                                    <div
                                                                        className={LCRD.inputIconProductImageZoom}
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '50%',
                                                                            left: '50%',
                                                                            transform: 'translate(-50%, -50%)',
                                                                            cursor: 'pointer',
                                                                            color: '#5b99f3',
                                                                            opacity: 0,
                                                                            transition: 'all 0.3s ease',
                                                                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                                                            borderRadius: '50%',
                                                                            padding: '8px',
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.currentTarget.style.opacity = '1';
                                                                            e.currentTarget.style.backgroundColor =
                                                                                'rgba(255, 255, 255, 0.9)';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.currentTarget.style.opacity = '0';
                                                                            e.currentTarget.style.backgroundColor =
                                                                                'rgba(255, 255, 255, 0.8)';
                                                                        }}
                                                                        onClick={() =>
                                                                            handleOpenModal(product.productImageUrl)
                                                                        }
                                                                    >
                                                                        <ZoomInIcon
                                                                            sx={{ fontSize: '32px' }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </TableCell>
                                                            <TableCell
                                                                className={LCRD.productDetailCell}
                                                                component="th"
                                                                scope="row"
                                                                style={{ textAlign: 'center' }}
                                                                width={100}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                >
                                                                    <b>{product.brandName}</b>
                                                                    <p>{product.productDescriptionOnWebSite}</p>
                                                                    <p>
                                                                        <b>{product.barcode}</b>
                                                                    </p>
                                                                    <div className={lcrDetailCls('linktxt', LCRD.linkProductDetail)}>
                                                                        <Link
                                                                            to={`/productdetail/${product?.optionId}`}
                                                                        >
                                                                            <b>
                                                                                {product.ozelKod1} - {product.renkKod}
                                                                            </b>
                                                                        </Link>
                                                                    </div>
                                                                    <p>{product.size}</p>
                                                                </div>
                                                            </TableCell>
                                                            <TableCell
                                                                align="right"
                                                                style={{ textAlign: 'center' }}
                                                                width={1}
                                                            >
                                                                <b>{product.piece}</b>
                                                            </TableCell>
                                                            <TableCell
                                                                align="right"
                                                                style={{ textAlign: 'center' }}
                                                                width={1}
                                                            >
                                                                {product.restockQuantity}
                                                            </TableCell>
                                                            <TableCell
                                                                align="right"
                                                                style={{ textAlign: 'center' }}
                                                                width={1}
                                                            >
                                                                <b>{product.nonRestockQuantity}</b>
                                                            </TableCell>
                                                            <TableCell
                                                                align="right"
                                                                style={{ textAlign: 'center' }}
                                                                width={1}
                                                            >
                                                                <b> {product.rejectedQuantity}</b>
                                                            </TableCell>
                                                            <TableCell
                                                                align="right"
                                                                style={{ textAlign: 'center' }}
                                                                width={1}
                                                            >
                                                                <b>{product.reasonDescription}</b>
                                                            </TableCell>
                                                            <TableCell
                                                                align="right"
                                                                style={{ textAlign: 'center' }}
                                                                width={1}
                                                            >
                                                                <b>{product.rejectedReason}</b>
                                                            </TableCell>
                                                            <TableCell
                                                                align="right"
                                                                style={{ textAlign: 'center' }}
                                                                width={1}
                                                            ></TableCell>

                                                            <TableCell
                                                                align="right"
                                                                style={{ textAlign: 'center' }}
                                                                width={1}
                                                            >
                                                                <p>{product.returnItemStatusKey}</p>
                                                            </TableCell>
                                                            <TableCell
                                                                align="right"
                                                                style={{ textAlign: 'center' }}
                                                                width={1}
                                                            >
                                                                <Chip
                                                                    color={product.isReturnable ? 'success' : 'error'}
                                                                    label={
                                                                        product.isReturnable
                                                                            ? t('refund.refundable')
                                                                            : t('refund.nonRefundable')
                                                                    }
                                                                />
                                                            </TableCell>
                                                            <TableCell
                                                                align="right"
                                                                style={{ textAlign: 'center' }}
                                                                width={1}
                                                            >
                                                                <Tooltip
                                                                    title={
                                                                        <h1>
                                                                            {product.returnMessages
                                                                                ?.replace('/n', '')
                                                                                .replace('/r', '')}
                                                                        </h1>
                                                                    }
                                                                >
                                                                    <span style={{ color: 'red' }}>
                                                                        <strong>
                                                                            {product.returnMessages
                                                                                ?.replace('/n', '')
                                                                                .replace('/r', '')}
                                                                        </strong>
                                                                    </span>
                                                                </Tooltip>
                                                            </TableCell>
                                                            {returnDetailData.showCompleteButtonForLostCargo && (
                                                                <TableCell
                                                                    align="right"
                                                                    style={{ textAlign: 'center' }}
                                                                    width={1}
                                                                >
                                                                    <IconButton
                                                                        className={lcrDetailCls('svg_icons', LCRD.inputIconRowActions)}
                                                                        size="small"
                                                                        onClick={(e) =>
                                                                            handleClickProductTable(e, product)
                                                                        }
                                                                    >
                                                                        <MoreVertIcon />
                                                                    </IconButton>
                                                                </TableCell>
                                                            )}
                                                        </TableRow>
                                                    </>
                                                ))}
                                        </TableBody>
                                    </Table>
                                    <Box className={LCRD.tableFooterTotal} sx={{ display: 'flex', margin: '16px 8px', padding: '8px' }}>
                                        <Typography
                                            sx={{ fontWeight: 'bold', fontSize: '18px', marginLeft: 'auto' }}
                                        >{`${t('return.totalPieces')}: ${
                                            returnDetailData?.totalProductCount
                                        }`}</Typography>
                                    </Box>
                                </TableContainer>
                        )}
                    </Grid>
                    {returnDetailData.showCompleteButtonForLostCargo && (
                        <Grid
                            sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}
                            size={{
                                xs: 12,
                            }}
                        >
                            <SCUIButton
                                className={LCRD.inputButtonCompleteReturn}
                                type="primary"
                                sizeType="fixed"
                                size="m"
                                disabled={returnDetailData.returnStatus === 'Completed' || isCompleting}
                                text={t('lostCargoReturnPageBuilder.completeReturn')}
                                onClick={() => handleCompleteReturn(returnDetailData)}
                            />
                        </Grid>
                    )}
                </Grid>
            </Box>
        </>
    );
}

export default LostCargoReturnDetailCustomGrid;
